import React, { useMemo } from 'react';
import type { SwampEvent } from '../types';
import { getTeamTheme, teamImageSrc } from '../teamTheme';
import { teamTotals, winningTeamNames } from '../scores';
import { WinnerCrown } from './WinnerCrown';

interface TotalScoreBoardProps {
   events: SwampEvent[];
   teamNames: string[];
}

export function TotalScoreBoard({ events, teamNames }: TotalScoreBoardProps) {
   const totals = useMemo(() => teamTotals(events, teamNames), [events, teamNames]);
   const winners = useMemo(() => winningTeamNames(totals), [totals]);
   const rankedTeams = useMemo(
      () => [...teamNames].sort((a, b) => totals[b] - totals[a]),
      [teamNames, totals]
   );

   return (
      <section className="swamp-section swamp-totals">
         <h2 className="swamp-section__title">Total Score</h2>
         <ol className="swamp-totals__list">
            {rankedTeams.map((teamName, index) => {
               const theme = getTeamTheme(teamName);
               const imageSrc = teamImageSrc(teamName);
               const isWinner = winners.includes(teamName);

               return (
                  <li
                     key={teamName}
                     className="swamp-totals__item"
                     style={{ borderColor: theme.color }}
                  >
                     <span className="swamp-totals__rank">#{index + 1}</span>
                     {imageSrc && (
                        <img src={imageSrc} alt="" className="swamp-totals__image" />
                     )}
                     <span className="swamp-totals__team" style={{ color: theme.color }}>
                        {teamName}
                        {isWinner && <WinnerCrown />}
                     </span>
                     <span className="swamp-totals__score">{totals[teamName]}</span>
                  </li>
               );
            })}
         </ol>
      </section>
   );
}
